import Navbar from "../../components/navigations";
import Footer from "../../components/footer";
import { useEffect, useState } from "react";
import { GetProductById } from "../../services/products";
import { useShoppingCart } from "../../context/ShoppingCartContext";
import { useNavigate } from "react-router-dom";
import {
  Dense_Button_Light,
  Dense_button_dark,
  Primary_button_dark,
  Primary_button_light,
} from "../../components/buttons";

import axios from "axios";
import { useSearchParams } from "react-router-dom";

export default function PRXLandingPage() {
  const [product, setProduct] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [formToDisplay, setFormToDisplay] = useState(false);

  const { getItemQuantity, cartItems } = useShoppingCart();

  async function getInitialData() {
    const _id = window.location.pathname.split("/").pop();
    const product = await GetProductById(_id);
    const quantity = getItemQuantity(_id);

    setProduct({
      ...product,
      quantity: quantity,
      company: product.image.split("/")[1],
      file: product.image.split("/")[2],
      fileName: product.image.split("/")[2].split(".")[0],
    });
  }

  useEffect(() => {
    getInitialData();
  }, [cartItems]);

  async function handleSubmit(e) {
    e.preventDefault();
    setDisabled(true);
    console.log(formData);

    try {
      const response = await axios.post("/api/v2/emails/prx-contact", formData);
      console.log(response.data);
      if (response.data.ok) {
        setFormToDisplay(true);
      } else {
        setErrors({
          message: "An error occurred. Please try again later.",
        });
      }
    } catch (error) {
      console.error(error);
      setErrors({
        message: "An error occurred. Please try again later.",
      });
    } finally {
      setDisabled(false);
    }
  }

  const STYLES = {
    background: { backgroundColor: "#fcfaf7" },
    text: { color: "black" },
    button: { backgroundColor: "#e5c2ff" },
    headerFont: {
      fontFamily: "swear-display,serif",
      fontWeight: 400,
      color: "black",
      fontSize: 32,
    },
    headerFontWhite: {
      fontWeight: 400,
      color: "white",
      textAlign: "center",
    },
    headerFontBlack: {
      fontWeight: 400,
      color: "black",
      textAlign: "center",
    },
    textFont: {
      fontFamily: "area-normal,serif",
      fontWeight: 400,
      color: "black",
    },
    gradientBG: {
      background:
        "linear-gradient(0deg, #fcfaf7 0, #d9d9d9 15%, #71295e 50%, #481339 85%)",
      backgroundColor:
        "linear-gradient(0deg, #fcfaf7 0, #d9d9d9 15%, #71295e 50%, #481339 85%)",
      padding: 0,
    },
  };

  return (
    <div style={{ scrollBehavior: "smooth" }}>
      <Navbar />
      <section
        className="white-background-section"
        style={{
          background: "transparent",
          backgroundColor: "transparent",
          padding: 0,
          background: "linear-gradient( #481339 85%)",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          paddingBottom: 0,
          maskImage:
            "linear-gradient(rgb(255, 255, 255) 100%, rgb(0, 0, 0) 0%)",
        }}
      >
        <img
          src={require("../../assets/images/prx-footer-bg.jpg")}
          loading="lazy"
          alt=""
          style={{
            width: "100%",
            height: "auto",
            position: "absolute",
            objectFit: "contain",
            objectPosition: "center",
            ...STYLES.gradientBG,
            opacity: 0.5,
            mixBlendMode: "overlay",
          }}
        />
        <div
          className="w-layout-blockcontainer container w-container"
          style={{ gap: 30, padding: 60 }}
        >
          <div className="header-xxl" style={STYLES.headerFontWhite}>
            PRX-T33: The No-Downtime Treatment That Delivers—without Peeling or
            Needles
          </div>
          <div className="header-s" style={STYLES.headerFontWhite}>
            Science-backed skin renewal for every skin type and season.
          </div>
          {/* <button
            className="button-dense-primary-dark full-width"
            style={{ backgroundColor: "#e5c2ff", color: "#0048ad" }}
            onClick={() => {
              const element = document.getElementById("createAccount");
              window.scrollTo({
                top: element.offsetTop,
                behavior: "smooth",
              });
            }}
          >
            Purchase PRX
          </button> */}
          <div>
            <video
              controls={false}
              width="100%"
              height="auto"
              autoPlay={true}
              loop="true"
              muted="true"
              src={require("../../assets/videos/prx-bg.mp4")}
              loading="lazy"
              alt=""
              className="product-image"
              style={{ padding: 10 }}
            />
          </div>
        </div>
      </section>
      <section id="How" className="light-background-section white">
        <div className="w-layout-blockcontainer container left-justify">
          <div className="paragraph-section">
            <div>
              <h5 className="paragraph-section-heading"></h5>
              <h1 className="header-xl">What Is PRX-T33?</h1>
              <p className="body-l pad-top-m">
                PRX-T33 is a non-invasive biorevitalization treatment that
                offers visible skin rejuvenation without exfoliation, flaking,
                or downtime. Developed in Italy and now widely used in U.S.
                medical aesthetic practices, PRX stimulates collagen through a
                patented combination of 33% TCA, hydrogen peroxide, and
                brightening agents—delivering results comparable to deeper
                treatments while keeping the skin barrier intact.
              </p>
              <p className="body-l pad-top-m">
                Unlike traditional peels, PRX-T33 works below the surface,
                making it ideal for layering with other modalities and safe to
                use year-round on all skin types.
              </p>

              <div className="w-layout-blockcontainer button-group ">
                <Primary_button_dark
                  link="https://wiqo.us/pages/contact?utm_source=MSN"
                  text="Get PRX Today"
                />
              </div>
            </div>
          </div>
          <div
            id="w-node-_8ff770a1-9997-4c80-5c92-623e14884223-14884223"
            className="w-layout-layout three-stack wf-layout-layout"
          >
            <div
              id="w-node-_8ff770a1-9997-4c80-5c92-623e14884224-14884223"
              className="w-layout-cell cell-8"
            >
              <div className="div-block-10">
                <img
                  loading="lazy"
                  src={require("../../assets/images/wiqo-prx-treatment.webp")}
                  alt=""
                  className="paragraph-card-image large"
                />
                <h2 className="paragraph-card-heading">
                  Two Targeted Formulas
                </h2>
                <p className="paragraph-card-details">
                  PRX is available in two advanced formulations to target
                  different patient needs:
                </p>
              </div>
            </div>
            <div
              id="w-node-_8ff770a1-9997-4c80-5c92-623e1488422b-14884223"
              className="w-layout-cell cell-7"
            >
              <div className="div-block-10">
                <img
                  loading="lazy"
                  src={require("../../assets/images/female-prx.webp")}
                  alt=""
                  className="paragraph-card-image"
                />
                <h2 className="paragraph-card-heading">PRX Derm Perfexion</h2>
                <p className="paragraph-card-details">
                  Ideal for patients under 40 or those with early signs of
                  aging. This formula is used once weekly for 4 sessions to
                  address dullness, fine lines, and mild laxity.
                </p>
              </div>
            </div>
            <div
              id="w-node-_8ff770a1-9997-4c80-5c92-623e14884232-14884223"
              className="w-layout-cell cell-7"
            >
              <div className="div-block-10">
                <img
                  loading="lazy"
                  src={require("../../assets/images/prx-demo.webp")}
                  alt=""
                  className="paragraph-card-image large"
                />
                <h2 className="paragraph-card-heading">PRX Plus</h2>
                <p className="paragraph-card-details">
                  Developed for patients 40+ or those with pigmentation or
                  deeper wrinkles. Delivered every other week over 5 sessions,
                  PRX Plus includes Arbutin for melanin regulation and is
                  especially effective for aging skin with discoloration or
                  uneven tone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="lightgrey-background-section">
        <div className="w-layout-blockcontainer container left-justify ">
          <div className="header-xs title-underline">
            Why Providers Choose PRX
          </div>
          <div className="header-xl pad-top-l">Why Providers Choose PRX</div>

          <ul className="body-l pad-top-m">
            <li>No downtime, no visible peeling</li>
            <li>Safe on all skin types and tones</li>
            <li>Integrates seamlessly into existing offerings</li>
            <li>
              High ROI: repeat visits, short appointment times, strong retail
              potential
            </li>
            <li>Pre-event, maintenance, or combination therapy enhancer</li>
            <li>Patient retention and satisfaction are high</li>
            <div className="w-layout-blockcontainer button-group ">
              <Primary_button_dark
                link="https://wiqo.us/pages/contact?utm_source=MSN"
                text="Get PRX Today"
              />
            </div>
          </ul>
        </div>
      </section>
      <section className="white-background-section">
        <div className="w-layout-blockcontainer container left-justify ">
          <div className="header-xs title-underline">
            Works Beautifully With Other Modalities
          </div>
          <div className="header-xl pad-top-l">
            PRX-T33 is a collagen-priming treatment that enhances results from:
          </div>

          <ul className="body-l pad-top-m">
            <li>Microneedling</li>
            <li>RF microneedling and ultrasound tightening</li>
            <li>Biostimulatory fillers (Sculptra, Radiesse)</li>
            <li>Toxin and HA filler treatments</li>
            <div className="w-layout-blockcontainer button-group ">
              <Primary_button_dark
                link="https://wiqo.us/pages/contact?utm_source=MSN"
                text="Get PRX Today"
              />
            </div>
          </ul>
        </div>
      </section>
      {formToDisplay ? (
        <section
          id="returnSection"
          className="lightgrey-background-section"
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "rgb(231, 255, 203)",
          }}
        >
          <div className="header-xl" style={{ textAlign: "center" }}>
            Thank you for reaching out to MedSpa Network.
          </div>
          <div className="header-s pad-top-s" style={{ textAlign: "center" }}>
            We will be in touch soon!
          </div>
        </section>
      ) : (
        <section
          className="lightgrey-background-section"
          style={{
            background: "transparent",
            backgroundColor: "transparent",
            padding: 0,
            background: "linear-gradient( #481339 85%)",
            overflow: "hidden",
            position: "relative",
            zIndex: 1,
            paddingBottom: 0,
            maskImage:
              "linear-gradient(rgb(255, 255, 255) 100%, rgb(0, 0, 0) 0%)",
          }}
        >
          <img
            src={require("../../assets/images/prx-footer-bg.jpg")}
            loading="lazy"
            alt=""
            style={{
              width: "100%",
              height: "auto",
              position: "absolute",
              objectFit: "contain",
              objectPosition: "center",
              ...STYLES.gradientBG,
              opacity: 0.5,
              mixBlendMode: "overlay",
            }}
          />

          <div
            className="w-layout-blockcontainer container left-justify "
            style={{ padding: 60 }}
          >
            <div className="header-xs  light title-underline">
              Ready to Offer PRX in Your Practice?
            </div>
            <div className="header-xl white pad-top-l">
              Bring the most-requested skin rejuvenation protocol to your
              treatment room.
            </div>
            <div
              className="w-layout-blockcontainer button-group "
              style={{ width: "100%" }}
            >
              <Primary_button_light
                link="https://wiqo.us/pages/contact?utm_source=MSN"
                text="Buy PRX"
              />
            </div>
            {/* <img
            src={require("../../assets/images/PRX-QR.png")}
            loading="lazy"
            alt=""
            className="qr-code"
          /> */}
            <div
              className="header-m light pad-top-l"
              style={{ color: "white", paddingTop: 100 }}
            >
              Want to learn more before you purchase?
            </div>
            <form onSubmit={(e) => handleSubmit(e)}>
              <input
                required
                name="name"
                type="text"
                placeholder="Name"
                className="form-input"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: 10,
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                }}
                onChange={(e) => {
                  setFormData({ ...formData, [e.target.name]: e.target.value });
                }}
              />
              <input
                required
                name="email"
                type="text"
                placeholder="Email"
                className="form-input"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: 10,
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                }}
                onChange={(e) => {
                  setFormData({ ...formData, [e.target.name]: e.target.value });
                }}
              />
              <input
                required
                name="phone"
                type="text"
                placeholder="Phone"
                className="form-input"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: 10,
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                }}
                onChange={(e) => {
                  setFormData({ ...formData, [e.target.name]: e.target.value });
                }}
              />
              <input
                required
                name="company"
                type="text"
                placeholder="Company"
                className="form-input"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: 10,
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                }}
                onChange={(e) => {
                  setFormData({ ...formData, [e.target.name]: e.target.value });
                }}
              />
              <input
                required
                name="message"
                type="text"
                placeholder="Message"
                className="form-input"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: 10,
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                }}
                onChange={(e) => {
                  setFormData({ ...formData, [e.target.name]: e.target.value });
                }}
              />
              <p className="" style={{ color: "red", fontSize: 18 }}>
                {errors?.message}
              </p>
              <div className="w-layout-blockcontainer button-group ">
                <button
                  disabled={disabled}
                  className="button-primary-light"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </section>
      )}

      {/* <section className="white-background-section">
        <div className="w-layout-blockcontainer container left-justify ">
          <div
            id="w-node-_93b5f37f-02d4-6d75-2e62-f9e86e6cd4a8-6df1ccd1"
            className="w-layout-layout double-stack large-picture-container wf-layout-layout"
          >
            <div
              id="w-node-_93b5f37f-02d4-6d75-2e62-f9e86e6cd4a9-6df1ccd1"
              className="w-layout-cell"
            >
              <img
                src={require("../../assets/images/cadaverLab.png")}
                loading="lazy"
                alt=""
                className="large-photo-left"
              />
            </div>
            <div
              id="w-node-_93b5f37f-02d4-6d75-2e62-f9e86e6cd4aa-6df1ccd1"
              className="w-layout-cell cell-12"
            >
              <img
                src={require("../../assets/images/Rectangle-5-1-p-1080.png")}
                loading="lazy"
                alt=""
                className="large-photo-right"
              />
              <img
                src={require("../../assets/images/Rectangle-4-2.png")}
                loading="lazy"
                alt=""
                className="large-photo-right"
              />
            </div>
          </div>
        </div>
      </section> */}
      <Footer />
    </div>
  );
}
